const React = require('react');
const withState = require('../../../../../utils/withState');
const {
  loadingSignOut$,
  account$, accountUpdate,
} = require('../../../../../emitters/account');
const WrapperWithLoading = require('../../../../dumb/WrapperWithLoading/B');
const ButtonNext = require('./Button/Next');


module.exports = withState(() => {
  return (state, props) => {
    const defaultState = props.defaultState || {};
    const message = defaultState.message || '';

    return (
      <WrapperWithLoading
        loading={state.loading}
      >
        {
          defaultState.rejected ? (
            <>
              <div
                className="f30 fw3 lh44 lts0em tl c0"
              >Your registration has been rejected</div>
              {message ? (<div
                className="mt20 f23 fw3 lh34 lts0em tl"
              >{message}</div>) : null}
              <div className="layoutRow fvaC fhaB mt190 mt54@m">
                <ButtonNext
                  onClick={account$.signOut}
                >Ok</ButtonNext>
              </div>
            </>
          ) : (
            <>
              <div
                className="f30 fw3 lh44 lts0em tl c0"
              >That&apos;s All.</div>
              <div className="mt20 f23 fw3 lh34 lts0em tl">
                Thank you for choosing Lunu as your payment partner!<br/>
                Welcome to the Lunu family.<br/>
                We will complete your onboarding in 2-3 days.
              </div>
              <div className="layoutRow fvaC fhaB mt190 mh-20 mt54@m (ph20)>1">
                <div>
                  <ButtonNext
                    onClick={accountUpdate}
                  >Refresh Status</ButtonNext>
                </div>
                <div>
                  <ButtonNext
                    onClick={account$.signOut}
                  >Logout</ButtonNext>
                </div>
              </div>
            </>
          )
        }
      </WrapperWithLoading>
    );
  };
}, {
  loading: loadingSignOut$,
});
